module.exports = {
  siteTitle: 'Slate Data', // Site title.
  siteTitleAlt: 'Google Cloud Partner | London', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://www.slatedata.co.uk', // Domain of your website without pathPrefix.
  companyName: 'Slate Data Ltd.',
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'A London data consultancy.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'slate-data', // Disqus shortname.
  userName: 'James Cottrill',
  userTwitter: 'jamescottrill_',
  userLocation: 'London',
  userDescription: '',
  copyright: 'Copyright © Slate Data 2022.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
  googleTagManagerID: 'GTM-WQ7V8C5'
}
